<template>
<div>
	<p v-if="insideTable && readonly" style="margin:0">
		{{ items.filter(c => localValue.includes(c.id)).map(c=> c[itemText]).join(' - ') || emptyState }}</p>
    <v-select class="bee-mutli-select"
		v-else
		:disabled="(readonly && !insideTable) || disabledValue"
		:rules="rules" 
		flat 
		@blur="$emit('blur')" 
		@change="$emit('change')" 
		hide-selected 
		:label="!insideTable ? label : ''"
		:outlined="!insideTable"
		:dense="!insideTable"
		clearable 
		multiple  
		:menu-props="{ offsetY: true }"
		style="width: 100%"
		:items="readonly ? localItems : items" 
		:item-text="itemText" 
		:item-value="itemValue" 
		@click:clear="$emit('input', value)" 
		:small-chips="!readonly" 
		:readonly="readonly"
		v-model="localValue"
		@keydown.enter.prevent="$emit('keydown-enter-prevent')"
		@keydown.esc.prevent="$emit('keydown-esc-preven')"
		@input="$emit('input', $event)"
		@focus="onFocus()"
		ref="BeeMultiSelect">
		<template v-slot:selection="{item}" >
            <v-chip close small close-icon="mdi-close-circle" @click:close="remove(item)">
                {{ findItemTextValue(item) }}
            </v-chip>
        </template>
		<template v-slot:no-data>
			<v-list-item>
				{{$t('no-data')}}
			</v-list-item>
		</template>
    </v-select>
</div>
</template>
<script>
import baseBeeComponent from "../../baseBeeComponent";
export default {
mixins: [baseBeeComponent],
props:["value", "rules", "label", "items", "itemText", "itemValue", "readonly", "emptyState", "insideTable", "disabled"],
name:"BeeMultiSelect",
data(){
	return {
		
	}
},
computed:{
	localValue: {
		get: function() {
			return this.value?.length > 0 ? this.value : (this.readonly ?  [null]: this.value)
		},
		set: function(value) {
			this.$emit('input', value)
		}
	},
	localItems(){
		return [{ [this.itemValue]: null, [this.itemText]: this.emptyState }, ...this.items]
	}
},
methods:{
	onFocus () {
      this.$refs.BeeMultiSelect.isMenuActive = true  // open item list
    },
	remove (item) {
		this.localValue.splice(this.localValue.indexOf(item), 1)
		this.localValue = [...this.localValue]
	},
	findItemTextValue(item){
		if (typeof this.itemText === 'function'){
			return this.itemText(item);
		}
		else if (typeof this.itemText === 'string' && this.itemText.length > 0){
			return item[this.itemText];
		}
	}
},
	i18n:{
		messages: {
			ar: { 'no-data': 'لا تتوفر بيانات' },
			en: { 'no-data': 'No data' },
			es: { 'no-data': 'Sin datos' },
		}
	}
}
</script>